<script setup lang="ts">
import CreateRequestDrawer from './create-request/CreateRequestDrawer.vue'

const props = defineProps<{
  title?: string
  stats: Array<{ label: string; price: number; currency: string }>
  tabs: Array<{ title: string; link: string }>
  countries: Array<{ label: string; value: string | number }>
  currencies: Array<{ label: string; value: string | number }>
  discountOptions: Array<{ label: string; value: string | number }>
  transferMethods: Array<{ label: string; value: string | number }>
}>()
</script>


<template>
    <div class="w-full">
        <h2 class="text-[22px] text-[#1b325a ] mb-7">{{ title }}</h2>
        <div class="w-full grid grid-cols-1 md:grid-cols-3 gap-6">
            <template v-for="(stat, index) in stats" :key="`stat-item-${index}`">
                <StatusCard :data="stat" />
            </template>
        </div>
    </div>
    <!-- Tabs  -->
    <Tabs :tabs="tabs" :isAdminPanel="true" class="mt-8">
        <template #actions>
            <div class="flex items-center gap-2 pb-1">
                <CreateRequestDrawer :countries="countries" :currencies="currencies" :discount-options="discountOptions"
                    :transfer-methods="transferMethods" />
            </div>
        </template>
    </Tabs>
</template>
